import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 引入自定义样式
import "./scss/elementui.scss";

import "animate.css";
import "wowjs/css/libs/animate.css";
import wow from "wowjs";
Vue.prototype.$wow = wow;

// 绑定 api
import api from "./util/api";
Vue.prototype.$api = api;

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
